<template>
  <div class="info-label">
    <div class="info-label-wrapper">
      <div class="label-icon black"> </div>
      <div class="label"> {{ label1 }} </div>
    </div>
    <div class="info-label-wrapper">
      <div class="label-icon grey"> </div>
      <div class="label"> {{ label2 }} </div>
    </div>
    <div class="info-label-wrapper">
      <div class="label-icon red"> </div>
      <div class="label"> {{ label3 }} </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfoLabel',
    props: ['label1', 'label2', 'label3']
  }
</script>

<style scoped>
.info-label {
  display: flex;
  flex-direction: row;
  gap: 12px;
  position: absolute;
  bottom: 50px;
  left: 100px;
}

.label-icon {
  width: 50px;
  height: 15px;
  border-radius: 5px;
}

.black {
  background: #252525;
}

.grey {
  background: #D0D5DD;
}

.red {
  background: var(--beel-primary);
}

.info-label-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: #252525;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 1050px) {
  .info-label{
    display: none;
  }
}
@media (max-width: 700px) {
  .info-label {
    left: 30px;
    bottom: 80px;

  }

  .label {
    font-size: 14px;
  }

  .label-icon {
    width: 30px;
    height: 10px;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/InfoLabel.vue